module.exports = __webpack_public_path__ + "img/characters.acb126d9.png";